<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- cargo form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código *"
          label-for="codigo"
          description="Escriba el código del cargo"
        >
          <b-form-input
            id="codigo"
            v-model="cargo.id_cargo"
            type="text"
            required
            placeholder="Código"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal del Cargo *"
          label-for="literal"
          description="Escriba el literal del cargo"
        >
          <b-form-input
            id="literal"
            v-model="cargo.descripcion"
            type="text"
            required
            placeholder="Literal del Cargo"
          ></b-form-input>
        </b-form-group>

        <!-- codigo area -->
        <b-form-group
          label="Código Área Cargo *"
          label-for="codigoArea"
          description="Escriba el código del área"
        >
          <b-form-input
            id="codigoArea"
            v-model="cargo.id_area"
            type="text"
            required
            placeholder="Código Área Cargo"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal del Área Cargo *"
          label-for="literal"
          description="Escriba el literal del área cargo"
        >
          <b-form-input
            id="literal"
            v-model="cargo.descripcion_area"
            type="text"
            required
            placeholder="Literal del Área Cargo"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import { ADD_CARGO, EDIT_CARGO } from "@/core/services/store/cargos.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "cargos-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: false,
      cargo: {
        id_cargo: null,
        descripcion: "",
        id_area: null,
        descripcion_area: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar cargo" : "Nuevo cargo";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.loading = true;
      const resp = await ApiService.get(
        `dic_cargos?id=${this.$route.params.id}`
      );
      this.cargo = resp.data.result[0];
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.loading = false;
      this.$router.push("/lists/cargos");
    },
    onSubmit() {
      this.loading = true;
      if (this.isEdit) {
        this.$store.dispatch(EDIT_CARGO, this.cargo).then(() => {
          this.cancel();
        });
      } else {
        this.$store.dispatch(ADD_CARGO, this.cargo).then(() => {
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
